import React from 'react'
import { useDispatch } from 'react-redux'
import Icon from 'components/Icon'
import { addModal } from 'features/modals/modalSlice'
import styled, { keyframes } from 'styled-components'
import { colors, _ } from 'utils'
import ValidationErrorList from 'features/export_import/ValidationErrorList'
import { ImportProgressType } from 'features/export_import/importExportSlice'

const move = keyframes`
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: 50px 50px;
    }
`

const S = {
    LabelWrapper: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
    `,
    Label: styled.p`
        margin-bottom: 0;
        font-size: 14px;
        line-height: 16px;
        font-weight: 700;
        color: ${colors.grayDescription};
    `,
    Errors: styled.div`
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 500;
        color: ${colors.danger};
        opacity: 0.75;
        cursor: pointer;
        &:hover {
            opacity: 1;
        }
    `,
    Bar: styled.div`
        position: relative;
        width: 100%;
        height: 4px;
        border-radius: 5px;
        background-color: ${colors.iconOpacity(0.2)};
        overflow: hidden;
    `,
    Progress: styled.div<{ width: number }>`
        position: relative;
        width: ${({ width }) => width}%;
        height: 100%;
        background-color: ${colors.primary};
        transition: 0.5s;
        z-index: 2;
    `,
    Loading: styled.div`
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1;
        background-size: 50px 50px;
        background-image: linear-gradient(
            -45deg,
            ${colors.primaryOpacity(0.2)} 25%,
            transparent 25%,
            transparent 50%,
            ${colors.primaryOpacity(0.2)} 50%,
            ${colors.primaryOpacity(0.2)} 75%,
            transparent 75%,
            transparent
        );
        animation: ${move} 1s linear infinite;
    `,
}

const ProgressBar = ({
    progress,
    isMinimizing,
    errors=[]
}: {
    progress: ImportProgressType
    isMinimizing?: boolean
    errors?: string[]
}) => {
    const dispatch = useDispatch()
    const isCompleted = progress.completed >= progress.total

    const showErrorList = () => {
        dispatch(addModal({
            header: _('import_file.error_list_header'),
            Component: ({ close: errorClose }: { close: () => void }) => (
                <ValidationErrorList errorsBE={errors} errorClose={errorClose} />
            ),
            backdrop: 'static'
        }))
    }
    return (
        <>
            <S.LabelWrapper>
                <S.Label>{`${isCompleted ? 'Completed ' : ''}${progress.completed}/${progress.total}`}</S.Label>
                {!!progress?.errorItems?.length && (
                    <S.Errors onClick={showErrorList}>
                        <span style={{ marginBottom: -3 }}>{`${progress.errorItems.length} errors`}</span>
                        {!isMinimizing && (
                            <Icon
                                icon="closeCircle"
                                color={colors.danger}
                                size={18}
                                style={{ marginLeft: 6 }}
                            />
                        )}
                    </S.Errors>
                )}
            </S.LabelWrapper>
            <S.Bar>
                <S.Progress width={(progress.completed / progress.total) * 100} />
                <S.Loading />
            </S.Bar>
        </>
    )
}

export default ProgressBar
